import { StateProvider, UrlRouterProvider } from '@uirouter/angularjs';

export function configRoute($stateProvider: StateProvider, $urlRouterProvider: UrlRouterProvider, $locationProvider: ng.ILocationProvider) {
    $urlRouterProvider.otherwise("/dashboard");
    $locationProvider.hashPrefix("");
}
configRoute.$inject = ["$stateProvider", "$urlRouterProvider", "$locationProvider"];


// WEBPACK FOOTER //
// ./app/app.config.ts